import React from "react";
import { useSelector } from "react-redux";
import NoDataFound from "../NoDataFound/NoDataFound";
import RenderStars from "./RenderStars";
import { useEffect, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const ReviewList = () => {
  const reduxData = useSelector((state: any) => state);
  const { store: { allReviewList, selectedStore } } = reduxData;
  const {t} = useTranslation();

  const [filteredReview, setFilteredReview] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState('ALL');


  // @@ function to sort review list
  const sortReview=(review:any)=>{
   return  review?.sort((a: any, b: any) => {
      return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
    });
  }
  useEffect(() => {
    setFilteredReview(sortReview(allReviewList));
  }, [allReviewList]);

  const handleSelectFilter = (val: any) => {
    const selectedVal = val;
    setSelectedRadio(selectedVal);

    if (selectedVal === 'ALL') {
      setFilteredReview(allReviewList);
    } else {
      const filteredData = allReviewList?.filter((i: any) => Math.floor(i?.rating) === selectedVal);
      setFilteredReview(filteredData);
    }
  };

  const returnCountOfRatings = (rating: any) => {
    if (rating === 'ALL') {
      return selectedStore?.rating_count || 0;
    }
    return allReviewList?.filter((item: any) => Math.floor(item.rating) === rating)?.length || '0';
  };

  return (
    <>
      <div className="flex justify-center mt-5">
        <div className="flex items-center justify-between mb-0 mt-12 md:mt-0 ">
          <h4 className="md:text-[2rem] text-2xl font-bold font-splekta">
            {t("Review.reviewOfThe")} {selectedStore?.store_name} 
          </h4>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row md:flex-row mt-4 lg:space-x-5  md:space-x-5 space-y-5 lg:space-y-0 md:space-y-0 w-full lg:w-[90vw] md:w-[95vw] mx-auto">
        {/* Left Section: Reviews */}

        {/* @@START recomended view for movile screen */}
        <div className="lg:w-[30%] md:w-[30%] w-full bg-white pe-5 ps-5 md:mt-0 lg:mt-0 md:hidden block">
          <div className="text-center shadow border border-gray-200 p-5 rounded-t-lg">
            {/* Average Rating */}
            <p className="text-3xl font-bold text-gray-800">{selectedStore?.rating?.toFixed(1) || 0}</p>
            <p className="text-sm text-gray-500">({selectedStore?.rating_count || 0} {t("Review.reviews")})</p>
            {/* Highly Recommended */}
            <p className="mt-4 text-lg text-green-600 font-semibold">{t("Review.highlyRecommended")}</p>
          </div>
        </div>
        {/* @@END recomended view for movile screen */}

        <div className="lg:w-[70%] w-full p-5 space-y-2 mb-5 overflow-y-scroll max-h-[570px] scrollbar-hidden">
          {filteredReview?.length > 0 ? (
            filteredReview.map((rItem: any, rIndex: number) => (
              <div key={rIndex} className="w-full mx-auto p-6 bg-white rounded-lg shadow border border-gray-200">
                {/* User Info and Rating */}
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center">
                    <p className="text-lg font-semibold text-gray-800">{rItem?.user?.first_name ?? rItem?.user?.name}</p>
                  </div>
                  <div className="flex items-center text-yellow-500">
                    <RenderStars rating={rItem?.rating} />
                  </div>
                </div>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center">
                    <p className="text-gray-700">{rItem?.review || "No review content available"}</p>
                  </div>
                  <div className="flex items-center text-yellow-500">
                    <p className="text-sm text-gray-500">{moment(rItem?.updated_at).format("lll")}</p>
                  </div>
                </div>

                {/* Review Text */}

              </div>
            ))
          ) : (
            <NoDataFound content={t("Review.noReviewsAvailable")}/>
          )}
        </div>

        {/* Right Section: Review Summary */}
        <div className="lg:w-[30%] md:w-[30%] w-full bg-white p-6 mt-4 md:mt-0 lg:mt-0 hidden md:block">
          <div className="text-center shadow border border-gray-200 p-5 rounded-t-lg">
            {/* Average Rating */}
            <p className="text-3xl font-bold text-gray-800">{selectedStore?.rating?.toFixed(1) || 0}</p>
            <p className="text-sm text-gray-500">({selectedStore?.rating_count || 0} {t("Review.reviews")})</p>
            {/* Highly Recommended */}
            <p className="mt-4 text-lg text-green-600 font-semibold">{t("Review.highlyRecommended")}</p>
          </div>
          <div className="mt-1 shadow border border-gray-200 rounded-b-lg p-5" >
            <div className="mt-4">
              <p className="font-bold">{t("Review.sortBy")}</p>
              {['ALL', 5, 4, 3, 2, 1].map((iR: any, index: any) => (
                <div
                  key={index}
                  className="flex items-center cursor-pointer mb-2"
                  onClick={() => handleSelectFilter(iR)}
                >
                  <input
                    type="radio"
                    name="rating-filter"
                    id={`rating-${iR}`}
                    value={iR}
                    checked={iR == selectedRadio}
                    style={{
                      width: '18px',  // Adjust size
                      height: '18px', // Adjust size
                      marginRight: '8px', // Space between radio and text
                      display: 'inline-block',
                    }}
                    className="cursor-pointer"
                  />
                  <p className="cursor-pointer text-gray-500" style={{ display: 'inline-block' }}>
                    {iR !== 'ALL' ? <RenderStars className={''} rating={iR} /> : <span className="text-sm">{iR}</span>}
                    {`(${returnCountOfRatings(iR)})`}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewList;
